import React, { useState, useRef, useEffect } from 'react';
import Icon from './AppIcon';
import { isFluxConfigured } from '../services/fluxService';

const baseModels = [
  { value: 'Gemini 3.1 Flash Image Preview', label: 'Ultra', provider: 'gemini' },
];

const fluxModels = [
  { value: 'Flux Pro', label: 'Lite', provider: 'flux' },
  { value: 'Flux Flex', label: 'Lite Creative', provider: 'flux' },
];

// Only show Flux models if API key is configured
const models = isFluxConfigured()
  ? [...baseModels, ...fluxModels]
  : baseModels;

const ModelSelectionDropdown = ({
  value = 'Gemini 3.1 Flash Image Preview',
  onChange,
  label = 'Model Selection',
  mobile = false,
  dropDirection = 'up',
  excludeFlux = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const availableModels = excludeFlux ? models.filter((m) => m.provider !== 'flux') : models;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const displayName = availableModels.find((m) => m.value === value)?.label || value;

  return (
    <div ref={ref}>
      <label className={`text-white/70 block ${mobile ? 'text-[10px] mb-1.5' : 'text-xs mb-2'}`}>
        {label}
      </label>
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-full glassmorphic-select bg-white/5 border border-white/10 flex items-center justify-between hover:border-orange-500/30 transition-all ${
            mobile ? 'rounded-xl px-3 py-2' : 'rounded-2xl px-4 py-3'
          }`}
        >
          <span className={`text-white truncate ${mobile ? 'text-xs' : 'text-sm'}`}>{displayName}</span>
          <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={mobile ? 14 : 16} className="text-white/50" />
        </button>

        {isOpen && (
          <div
            className={`absolute z-50 w-full ${dropDirection === 'down' ? 'top-full mt-2' : 'bottom-full mb-2'} border border-white/10 shadow-2xl overflow-hidden ${
              mobile ? 'rounded-xl' : 'rounded-2xl'
            }`}
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.95)', backdropFilter: 'blur(8px)' }}
          >
            {availableModels.map((model) => (
              <button
                key={model.value}
                onClick={() => { onChange(model.value); setIsOpen(false); }}
                className={`w-full flex items-center justify-between px-4 py-3 transition-all border-b border-white/5 last:border-b-0 ${
                  value === model.value
                    ? 'bg-orange-500/20 hover:bg-orange-500/30'
                    : 'hover:bg-white/5'
                }`}
              >
                <span className={`${mobile ? 'text-xs' : 'text-sm'} ${value === model.value ? 'text-white font-medium' : 'text-white/70'}`}>
                  {model.label}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModelSelectionDropdown;
